(ns livefeed.footer.login
  (:require [livefeed.i18n :refer [translate]]))

(defn component [login-fn]
  [:footer.yle-livefeed__footer
   [:button.yle-livefeed__footer__login {:on-click login-fn}
    (translate :login-and-discuss)]])
